import { createSlice } from '@reduxjs/toolkit';

const initState = {
	studioPlayList: []
};

export const studioPlayListSlice = createSlice({
	name: 'studioPlayList',
	initialState: initState,
	reducers: {
		getStudioPlayList: (state, { payload }) => {
			state.studioPlayList = payload;
		}
	}
});

export const { getStudioPlayList } = studioPlayListSlice.actions;

export default studioPlayListSlice.reducer;
